<template>
  <div>
    <!-- 授权公众号提示 -->
    <div class="auth-tips-box" v-show="isShowAuthTip  && activeIndex == 5">
      <img class="tips-icon" src="../../assets/img/h5/official/home_icon_notice.png" />
      <span class="tips-info">您还未授权公众号，请先 <span @click="linkTo(6)">授权公众号</span></span>
      <img class="tips-icon" src="../../assets/img/h5/official/home_icon_arrow_red.png" style="margin-left: -8px;"/>
    </div>
    <!-- 授权公众号提示 -->
    <!-- 导航栏-->
    <div class="nav-wrap">
      <div class="flex-row">
        <div class="nav-left">
          <img src="../../assets/img/h5/logo.png" alt="LOGO" @click="linkTo(0)">
        </div>
        <div class="nav-right">
          <div class="navbar-nav">
            <div class="navbar-box">
              <div class="navbar-div"  v-show="!$store.getters.userToken">
                <div>
                  <span @click="linkTo(1)">登录</span>
                </div>
                <div>
                  <span @click="linkTo(2)">注册</span>
                </div>
              </div>
              <div class="user-info" v-if="$store.getters.userToken">
                <div>
                  <span class="mobile">{{$store.getters.userInfo ? $store.getters.userInfo.nickname : ''}}</span>
                  <span class="exit" @click="userExit">退出</span>
                </div>
              </div>
              <div class="nav-btn">
                <img @click="showImg" v-show="isShowMore" src="../../assets/img/h5/nav_btn_more.png" alt="">
                <img @click="showImg" v-show="!isShowMore" src="../../assets/img/h5/nav_btn_cancel.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 导航栏-->
    <div class="select-tab" v-show="!isShowMore">
      <div class="select-box" :class="(activeIndex == 0) ? 'active':''" @click="linkTo(0)">首页</div>
      <div class="select-box" :class="(activeIndex == 3) ? 'active':''"  @click="linkTo(3)">我要推广</div>
      <div class="select-box" :class="(activeIndex == 5) ? 'active':''"  @click="linkTo(5)">公众号入驻</div>
      <div class="select-box" :class="(activeIndex == 4) ? 'active':''"  @click="linkTo(4)">联系我们</div>
      <div class="select-box" :class="(activeIndex == 7) ? 'active':''"  @click="linkTo(7)">导出中心</div>
    </div>
  </div>

</template>

<script>
  import { getToken, getIsAuthOfficial, getHasPackage } from '@/utils/auth'
  export default {
    name: 'Tab',
    data(){
      return{
        //showModel: false,
        isShowMore: true,
        needLoginIndex: [3,4],
      }
    },
    computed: {
      activeIndex: function () {
        let path = this.$route.path;
        let activeIndex = 0
        if(path.indexOf("promotion") > -1) {
          activeIndex = 3
        }else if( path.indexOf("official") > -1) {
          activeIndex = 5
        }else if( path.indexOf("contact") > -1) {
          activeIndex = 4
        }
        return activeIndex;
      },
      isShowAuthTip: function (){
        var isShowAuthTip = false;
        let path = this.$route.path;
        if (getIsAuthOfficial() !== 'true' && path === '/h5/official/statistics') {
          isShowAuthTip = true;
        }
        return isShowAuthTip;
      }
    },
    methods:{
      showImg () {
        this.isShowMore = ! this.isShowMore;
      },
      linkTo: function (type) {
        var isNext = true
        var that = this
        if (this.needLoginIndex.indexOf(type) > -1) {
          var token = getToken()
          if (token === undefined || token === '') {
            isNext = false
            // 弹窗提示
            this.$dialog.alert({
              title: '提示',
              message: '您还未登录，请先登录！',
              theme: 'round-button',
            }).then(() => {
              // on close
              this.$router.push('/h5/login')
              this.isShowMore = ! this.isShowMore;
            })
          }
        }
        if (isNext == false) {
          return
        }
        this.$store.dispatch('h_nav/changeActiveIndex', type)
        var tabActiveIndex = this.$store.getters.tabPromotionActiveIndex;
        var url = '/h5/promotion/home';
        switch (tabActiveIndex) {
          case 1:
            url = '/h5/promotion/manage'
            break;
          case 2:
            url = '/h5/promotion/report'
            break;
          case 3:
            url = '/h5/promotion/order'
            break;
          case 4:
            url = '/h5/promotion/money'
            break;
          case 5:
            url = '/h5/promotion/account'
            break;
          case 6:
            url = '/h5/promotion/setting'
            break;
        }
        switch (type) {
          case 1://登录
            this.$router.push('/h5/login')
            break;
          case 2://注册
            this.$router.push('/h5/register')
            break;
          case 3://我要推广
            this.$router.push(url)
            this.isShowMore = ! this.isShowMore;
            break;
          case 4://联系我们
            this.$router.push('/h5/contact')
            break;
          case 5://公众号入驻
            this.$router.push('/h5/official/home')
            break;
          case 6://公众号授权
            var hasPackage = (getHasPackage() === 'true')
            if (hasPackage === false) {
              this.$store.dispatch('h_nav/changeOfficialActiveIndex', '7')
              this.$router.push('/h5/official/dialog')
              return;
            } else {
              this.$store.dispatch('h_nav/changeOfficialActiveIndex', '6')
              this.$router.push('/h5/official/authorization')
            }
            break;
          case 7:// 导出中心
            this.$router.push('/h5/exportCenter/index')
            break;
          case 0:
            this.$router.push('/h5/home')
            break;
        }
      },
      userExit(){
        this.$store.dispatch('nav/changeIsGoOfficial', 0)
        this.$store.dispatch('user/logout')
        this.$toast('退出成功')
        this.$router.push('/h5/home')
      },
    }
  }
</script>

<style lang="less" scoped>
  .auth-tips-box{
    height: 32px;
    padding: 5px 13px;
    font-family: Alibaba-PuHuiTi-R;
    font-size: 12px;
    color: #666666;
    text-align: justify;
    line-height: 17px;
    .tips-icon{
      width: 22px;
      margin-right: 3px;
    }
    .tips-info{
      vertical-align: middle;
      span{
        cursor: pointer;
        font-family: Alibaba-PuHuiTi-M;
        color: #FF4F76;
      }
    }
  }
  .nav-wrap{
    height: 44px;
    background: #FF8622;
    font-family: Alibaba-PuHuiTi-R;
    .nav-left{
      float: left;
      padding-left: 5px;
      img{
        height: 44px;
      }
    }
    .nav-right{
      float: right;
      color: #FFFFFF;
      .navbar-nav{
        display: inline-block;
        .navbar-box {
          cursor: pointer;
          .navbar-div{
            padding-right: 0px;
          }
          div{
            line-height: 44px;
            float: left;
            padding-right: 25px;
          }
          .user-info{
            float: left;
            padding-right: 0;
          }
          .nav-btn{
            float: left;
            padding-right: 15px;
            img{
              height: 22px;
            }
          }
        }
      }
    }
  }
  .select-tab{
    width: 100%;
    height: auto;
    background: #FFFFFF;
    color: #222222;
    position: absolute;
    z-index: 5;
    box-shadow: 0 1px 0 0 #EFEFEF;
    font-family: Alibaba-PuHuiTi-R;
    .select-box{
      padding-left: 20px;
      height: 50px;
      line-height: 50px;
    }
    .select-box.active{
      color: #FF8622;
      background: #F5F5F5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/h5/Nav.vue